// extracted by mini-css-extract-plugin
module.exports = {"appShell":"AppShell_appShell__Zt_1x"};